import { Product } from 'types/common-types'

import ProductCard from './ProductCard'
import ProductList from './ProductList'

interface Props {
	items: Product[]
	view: 'grid' | 'list'
	region: 'ladoe' | 'standard' | 'teks'
}

export default function ViewController({ items, view, region }: Props) {
	return (
		<div>
			{view === 'grid' && (
				<div className="mt-10">
					<ProductCard products={items} region={region} />
				</div>
			)}
			{view === 'list' && (
				<div className="mt-10">
					<ProductList products={items} region={region} />
				</div>
			)}
		</div>
	)
}
